




















// @ is an alias to /src
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import $ from 'jquery';
import MainNav from '@/components/common/MainNav.vue';
import Footer from '@/components/common/Footer.vue';
import _ from 'underscore';
import { Diagram } from './libs/com/MetaPattern/MDA/Designer/Repository/Diagram';
import { APP } from './api/com/MetaPattern/MDA/MD/Base/APP';
import { EnumPersistenceStatus } from './api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { BEComponent } from './api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { IDEContext } from './libs/com/MetaPattern/Product/IDE/IDEContext';
import { APPComponent } from './api/com/MetaPattern/MDA/MD/APPModel/APPComponent';

@Component({
  components: {
    MainNav,
    Footer
  }
})

export default class App extends Vue {
  mounted() {
    // TODO：设置VUEX
    // TODO: 应该改为多页程序
    if (IDEContext.instance.users.length === 0) {
      this.$router.push('/login');
      return;
    }
    if (IDEContext.instance.curUser !== null) {
      this.$store.dispatch('User/setUserAction', IDEContext.instance.curUser);
    } else {
      this.$router.push('/UserSelect');
      return;
    }
    if (this.isLogin && !this.hasInitDone) {
      this.$router.push('/loginInit');
      return;
    }
    this.init();
  }

  updated() {
    this.init();
  }

  init() {
    this.resize();
    window.onresize = _.debounce(this.resize, 100);
    window.onbeforeunload = (e: any) => {
      if (!this.isModified) {
        return;
      }

      // 通知浏览器不要执行与事件关联的默认动作
      e.preventDefault();
      // Chrome 需要 returnValue 被设置成空字符串
      e.returnValue = '';
    };
  }

  resize() {
    document.getElementById('pageBody').style.height = (document.body.clientHeight - 60).toString() + 'px';
  }

  get curUserId() {
    return this.$store.state.User.userId;
  }

  get isModified(): boolean {
    let modifed = false;
    const find = this.$store.state.ModuleMD.diagrams.find((diagram: Diagram) => diagram.isModified);
    if (find) {
      modifed = true;
    }
    if (!modifed) {
      const findApp = this.$store.state.ModuleMD.apps.find((app: APP) => app.persistenceStatus !== EnumPersistenceStatus.None);
      if (findApp) {
        modifed = true;
      }
    }
    if (!modifed) {
      this.$store.state.ModuleMD.apps.forEach((app: APP) => {
        const findAPPCom = app.aPPComponents.find((component: APPComponent) => component.persistenceStatus !== EnumPersistenceStatus.None);
        if (findAPPCom) {
          modifed = true;
        }
        const findCom = app.bEComponents.find((component: BEComponent) => component.persistenceStatus !== EnumPersistenceStatus.None);
        if (findCom) {
          modifed = true;
        }
      });
    }
    return modifed;
  }

  get isLogin() {
    return IDEContext.instance.isLogin;
  }

  /** 是否完成初始化，完成后才能跳转到具体的页面 */
  get hasInitDone() {
    return this.$store.state.User.hasInitDone;
  }
};

